"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.placementsWithArrow = exports.placements = exports.default = void 0;
var autoAdjustOverflow = {
  adjustX: true,
  adjustY: true
};
var OFFSETWITHARROW = 11.8 / 2 + 4; // 确保箭头尖顶与触发组件距离4px
var placements = exports.placements = {
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4]
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4]
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4]
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4]
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4]
  }
};
var placementsWithArrow = exports.placementsWithArrow = {
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -OFFSETWITHARROW]
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -OFFSETWITHARROW]
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -OFFSETWITHARROW]
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, OFFSETWITHARROW]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, OFFSETWITHARROW]
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, OFFSETWITHARROW]
  }
};
var _default = exports.default = placements;